export default {
  current_status: {
    initial: {
      key: 'initial',
      label: 'No invite sent',
    },
    invited: {
      key: 'invited',
      label: 'Pending completion',
    },
    completed: {
      key: 'completed',
      label: 'Valid',
    },
    expired: {
      key: 'expired',
      label: 'Expired',
    },
    submitted: {
      key: 'submitted',
      label: 'Submitted',
    },
  },
};
